<template>
    <v-app id="inspire" >
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex sm6>
                        <v-card class="elevation-10" max-width="500px">
                            <v-toolbar class="elevation-0">
                                <v-spacer></v-spacer>
                                <v-toolbar-title >Alteração da senha</v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-layout row>
                                    <v-flex grow> </v-flex>
                                    <v-flex shrink>
                                        <v-img src="/images/nha_fatura.png" style="width: 80px"></v-img>
                                    </v-flex>
                                    <v-flex grow>  </v-flex>
                                </v-layout>

                                <v-form>
                                    <v-text-field
                                          v-model="newPassword"
                                          prepend-icon="lock"
                                          label="Nova Senha"
                                          :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                          :type="showPassword ? 'text' : 'password'"
                                          @click:append="showPassword = !showPassword"
                                          :error-messages="newPasswordErrors"
                                          @blur="$v.newPassword.$touch()">
                                    </v-text-field>

                                    <v-text-field
                                          v-model="confNewPassword"
                                          prepend-icon="lock"
                                          label="Confirmar nova senha"
                                          :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                          :type="showPassword ? 'text' : 'password'"
                                          @click:append="showPassword = !showPassword"
                                          @keyup.enter="changePass"
                                          :error-messages="confNewPasswordErrors"
                                          @blur="$v.confNewPassword.$touch()">
                                    </v-text-field>
                                </v-form>

                                <v-layout row>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" small outline :disabled="tryLoginLoading"
                                           @click="$router.push('dashboard')">Voltar para Login</v-btn>
                                </v-layout>
                                <v-progress-linear
                                        indeterminate
                                        v-if="tryLoginLoading"
                                        color="primary"
                                        height="2"
                                        value="15"
                                ></v-progress-linear>

                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-btn color="primary" block
                                   :loading="loading"
                                   :disabled="loading || $v.$invalid || tryLoginLoading"
                                   @click="changePass">Alterar senha</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import Vue from 'vue';
    import {minLength, sameAs , required} from 'vuelidate/lib/validators'
    export default {
        name: "PasswordReset",
        created(){
            console.log('route', this.$route.query.reset_password_token);
            this.token = this.$route.query.reset_password_token;
        },
        data(){
            return {
                newPassword: '',
                confNewPassword: '',
                loading: false,
                showPassword: false,
                token: '',
                showEmailSentAlert: false,

                email: '',
                tryLoginLoading: false,

            }
        },

        validations: {
            newPassword: {
                required,
                minLength: minLength(6),
            },
            confNewPassword: {
                sameAsPassword: sameAs('newPassword')
            }
        },

        methods: {
            changePass(){
                
                try {
                    this.loading = true;
                    Vue.axios.post('reset_password', {
                        token: this.$router.currentRoute.query.token,
                        password: this.newPassword,
                    }).then(response => {
                        this.consoleLog('forgotPassword:.: ', response);
                        if(response.data.error === 'token_not_found'){
                            this.showSnackBar('Erro: Token desconhecido');
                            return;
                        }else if(response.data.error === 'token_expired'){
                            this.showSnackBar('Erro: Token expirado');
                            return;
                        }else if (!response.data.success) {
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }

                        this.email = response.data.user.email;

                        this.tryLoginLoading = true;
                        this.$store.dispatch('login', {
                            email: this.email,
                            password: this.newPassword,
                        }).then(response => {
                            
                            if(response === 'wrong-credential') {
                                this.showSnackBar('Email ou senha inválido', 'error');
                                return;
                            }else if(response === 'no-access'){
                                this.showSnackBar('Não tens acesso para entrar em Nhafatura', 'info');
                                return;
                            }else if(!response.data.success){
                                this.showSnackBar('Ocorreu um erro. Por favor tente novamente.', 'info');
                                return;
                            }

                            this.$router.push({ name: 'dashboard' });
                        }).catch(e => {
                            this.consoleLog(e);
                        }).finally(()=>{
                            this.tryLoginLoading = false;

                        })

                    }).catch(e => {
                        this.showSnackBar('Ocorreu um erro. Por favor tente mais tarde!', 'error');
                        this.consoleLog(e);
                    }).finally(()=>{
                        this.loading = false;
                    })

                }catch (e) {
                    // Error is handled in the (login auth.js)
                }
            },

        },

        computed: {
            newPasswordErrors () {
                const errors = [];
                if (!this.$v.newPassword.$dirty) return errors;
                !this.$v.newPassword.required && errors.push('Introduza nova senha');
                !this.$v.newPassword.minLength && errors.push('Mínimo 6 charateres');
                return errors
            },
            confNewPasswordErrors(){
                const errors = [];
                if (!this.$v.confNewPassword.$dirty) return errors;
                !this.$v.confNewPassword.sameAsPassword && errors.push('Não são iguais');
                return errors
            },
        }
    }
</script>

<style scoped>

</style>